import { render } from "./CompassFrame.vue?vue&type=template&id=8504a28a&scoped=true"
import script from "./CompassFrame.vue?vue&type=script&lang=js"
export * from "./CompassFrame.vue?vue&type=script&lang=js"

import "./CompassFrame.vue?vue&type=style&index=0&id=8504a28a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8504a28a"]])

export default __exports__